
import React, { Component } from 'react';
//import '../App.css';

class CompanyTile extends Component {
  render() {
    return (
      <div className="hover-grow white-background medium-padding centered-text">
        <img alt="" className="full-width" src={this.props.logo} style={{'maxWidth':'230px'}} />
        <h4 className="uppercase" style={{'marginTop':'0px'}}>{this.props.company}</h4>
        <p className="subheading" style={localStyles.minHeight}>{this.props.description}</p>
      </div>
    );
  }
}

export default CompanyTile;

const localStyles = {
  minHeight:{
    minHeight:'55px'
  }
}



// WEBPACK FOOTER //
// ./src/components/companyTile.js